import React from 'react';
import { Header } from 'semantic-ui-react';
import { withResponsiveContainerNav, PageContainer } from 'feature/shared/containers/Containers';

const LabUsers = props => {
  return (
    <PageContainer>
      <Header>Lab - List Users</Header>
    </PageContainer>
  )
}

export default withResponsiveContainerNav(LabUsers);